export const environment = {
  production: false,
  //baseAPIURL: 'https://lios-api.qa.toyota.com/liosop/eboiapi/api/v1',
  baseAPIURL: 'https://ts.stage.portal.toyotasupplier.com/liosop/eboiapi/api/v1',
  TENANT_ID: 'https://login.microsoftonline.com/tmnatest.onmicrosoft.com',
	CLIENT_ID: '9d822665-267a-4ec4-83e5-f1002b928b0e',
  REDIRECT_URL: 'https://eboi.qa.lios.toyota.com/',
  LIOS_HOME_URL: 'https://qa.lios.toyota.com/',
  APM_DS_URI: 'https://api.qa.lios.toyota.com/apm/graphql',
  SCOPES: ['https://tmnatest.onmicrosoft.com/e45b42dc-670d-4640-b95b-a24d12e73448/user_impersonation'],
  FILE_UPLOAD_URI: "https://upload.qa.lios.toyota.com",
  WEBSOCKET_URI: "wss://v5tflp0a5k.execute-api.us-east-1.amazonaws.com/qa/",
  TEMPLATE_EXCEL_URI: "https://template.qa.lios.toyota.com",
  TASK_MANAGER: 'https://taskmanager.qa.lios.toyota.com',
  AET: 'https://ts.stage.portal.toyotasupplier.com/aet',
  ALARMS: 'https://alarms.qa.lios.toyota.com',
  FORECAST_ADMIN_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/forecast',
  CO2: 'https://liosapps.qa.toyota.com/co2/lp-upload',
  COST_PLANNING: 'https://costplanning.qa.lios.toyota.com',
  EBOI: 'https://eboi.qa.lios.toyota.com',
  TLD: 'https://tld.qa.lios.toyota.com',
  DD: 'https://ts.stage.portal.toyotasupplier.com/lios/delayindex#/delayeddispatch',
  REPORTS: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=11db23f6-28df-4b47-bf4d-03bb6cab9246&ctid=8c642d1d-d709-47b0-ab10-080af10798fb&experience=power-bi',
  EXPORT: 'https://export.qa.lios.toyota.com',
  GROUPI: 'https://liosapps.qa.toyota.com/groupi',
  SCHEDULE_JOB: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
  SCHEDULE_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
  TLMS_SEND: 'https://ts.stage.portal.toyotasupplier.com/lios/tlmssend',
  ALLO: 'https://allo.qa.lios.toyota.com',
};
